module.exports = __webpack_public_path__ + "img/HiwaQader.eadf7470.jpg";